import { HttpClient } from './httpClient';
import { API_URL } from './RestAPI';
import apiHeaders from './apiHeaders';
import { setUrlForGetRequest } from './sharedFunctions';

const Notifications_API = `${API_URL}/notifications`;

const getNotifications = (params, dependent = {}) => {
  const url = setUrlForGetRequest(Notifications_API, params);
  return HttpClient.get(url, apiHeaders(dependent));
};

const getNotification = (id) => {
  return HttpClient.get(`${Notifications_API}/${id}`, apiHeaders());
};

const markAsRead = (id) => {
  return HttpClient.put(`${Notifications_API}/${id}/read`, {}, apiHeaders());
};

const markAllAsRead = () => {
  return HttpClient.put(`${Notifications_API}/read-all`, {}, apiHeaders());
};

const removeNotification = (id) => {
  return HttpClient.delete(`${Notifications_API}/${id}`, apiHeaders());
};

const NotificationsApi = {
  getNotifications,
  getNotification,
  markAsRead,
  markAllAsRead,
  removeNotification,
};

export { NotificationsApi };